import { useSyncExternalStore } from "react";

// Shared, persisted sidebar width/collapsed state — a tiny external store
// (not Redux) so side-nav.jsx can drive the SAME "--SideNav-width" CSS
// variable that layout.jsx / AdminLayout.jsx already read for the main
// content's left padding, without those two files needing their own state.
const WIDTH_KEY = "ms_sidenav_width";
const COLLAPSED_KEY = "ms_sidenav_collapsed";
export const SIDENAV_EXPANDED_MIN = 200;
export const SIDENAV_EXPANDED_MAX = 250; // = the default: the sidebar can be dragged NARROWER (to the left), never wider
export const SIDENAV_COLLAPSED_WIDTH = 84;
const DEFAULT_WIDTH = 250;

const readWidth = () => {
  const n = Number(localStorage.getItem(WIDTH_KEY));
  return Number.isFinite(n) && n > 0 ? Math.max(SIDENAV_EXPANDED_MIN, Math.min(SIDENAV_EXPANDED_MAX, n)) : DEFAULT_WIDTH;
};

let state = {
  width: readWidth(),
  collapsed: localStorage.getItem(COLLAPSED_KEY) === "1",
};
let listeners = [];
const notify = () => listeners.forEach((fn) => fn());

export const sideNavLayout = {
  getSnapshot: () => state,
  getExpandedWidth: () => state.width,
  getCollapsed: () => state.collapsed,
  setWidth: (w) => {
    const clamped = Math.max(SIDENAV_EXPANDED_MIN, Math.min(SIDENAV_EXPANDED_MAX, Math.round(w)));
    if (clamped === state.width) return;
    state = { ...state, width: clamped };
    localStorage.setItem(WIDTH_KEY, String(clamped));
    notify();
  },
  setCollapsed: (c) => {
    if (c === state.collapsed) return;
    state = { ...state, collapsed: c };
    localStorage.setItem(COLLAPSED_KEY, c ? "1" : "0");
    notify();
  },
  subscribe: (cb) => {
    listeners.push(cb);
    return () => { listeners = listeners.filter((fn) => fn !== cb); };
  },
};

// Current effective pixel width (collapsed rail width, or the resizable
// expanded width), reactive — used by side-nav.jsx itself AND kept in sync
// with the global "--SideNav-width" CSS var so the page layout follows it.
export function useSideNavWidth() {
  const s = useSyncExternalStore(sideNavLayout.subscribe, sideNavLayout.getSnapshot);
  return s.collapsed ? SIDENAV_COLLAPSED_WIDTH : s.width;
}

export function useSideNavCollapsed() {
  const s = useSyncExternalStore(sideNavLayout.subscribe, sideNavLayout.getSnapshot);
  return s.collapsed;
}
